import { GetAccommodationResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export interface CreateAccommodationPayload {
    name: string
    checkInDate: string
    checkOutDate: string
    guestUserIds: number[]
    notes?: string | null
    links?: string[]
    location?: {
        fullText: string
        primaryText?: string | null
        secondaryText?: string | null
        googlePlaceId?: string | null
        googleTypes?: string[]
    } | null
}

export const useCreateAccommodation = createTripMutation<
    GetAccommodationResponse,
    { tripId: string; accommodationData: CreateAccommodationPayload }
>({
    mutationFn: async ({ tripId, accommodationData }) => {
        const response = await api.post<GetAccommodationResponse>(`/trips/${tripId}/accommodations`, accommodationData)
        return response.data
    },
    invalidate: ({ tripId }) => [queryKeys.accommodations(tripId)],
})
